import * as React from 'react';
import { Detail } from '@ane/ui-components/lib/components/Detail';
import { GridRow, GridCol } from '@ane/ui-components/lib/components/Grid';
import _ from 'lodash';
import { DataLocationStorageType } from '../../../DataSourceCreate/models/DataSourceDataCommon';
export var LocationKeyDetailLabel;
(function (LocationKeyDetailLabel) {
    LocationKeyDetailLabel["VC"] = "VC";
    LocationKeyDetailLabel["DataPath"] = "Data path";
    LocationKeyDetailLabel["EndPoint"] = "End Point";
    LocationKeyDetailLabel["Cluster"] = "Cluster";
    LocationKeyDetailLabel["Url"] = "Key vault URL";
    LocationKeyDetailLabel["SecretName"] = "Secret name";
    LocationKeyDetailLabel["ServicePrincipalName"] = "Service principal name";
    LocationKeyDetailLabel["StorageAccount"] = "Storage account";
    LocationKeyDetailLabel["Container"] = "Container";
    LocationKeyDetailLabel["RetentionDays"] = "Retention days";
    LocationKeyDetailLabel["RetentionDaysErrorMsg"] = "Message for invalid data period";
    LocationKeyDetailLabel["ManagedIdentityName"] = "Managed identity name";
})(LocationKeyDetailLabel || (LocationKeyDetailLabel = {}));
const locationWidth = {
    VC: {
        xl: 2,
        lg: 2,
        md: 3,
    },
    DataPath: {
        xl: 6,
        lg: 6,
        md: 6,
    },
    EndPoint: {
        xl: 6,
        lg: 6,
        md: 6,
    },
    RetentionDays: {
        xl: 6,
        lg: 6,
        md: 6,
    },
    RetentionDaysErrorMsg: {
        xl: 6,
        lg: 6,
        md: 6,
    },
    Cluster: { xl: 3, lg: 4, md: 5 },
    StorageAccount: { xl: 2, lg: 2, md: 3 },
    Container: { xl: 2, lg: 2, md: 3 },
    SecretName: { xl: 2, lg: 2, md: 3 },
    ServicePrincipalName: { xl: 2, lg: 2, md: 3 },
    Url: { xl: 4, lg: 4, md: 6 },
    ManagedIdentityName: { xl: 2, lg: 2, md: 3 },
};
class DataSourceLocationView extends React.Component {
    render() {
        const data = this.props.dataSource;
        let res = [];
        let resKeyVault = [];
        let items = {};
        if (data === null || data === void 0 ? void 0 : data.StorageType) {
            if (data.StorageType === DataLocationStorageType.Cosmos) {
                items = data.CosmosLocation;
            }
            else if (data.StorageType === DataLocationStorageType.AzureBlob) {
                items = data.AzureBlobLocation;
            }
            else if (data.StorageType === DataLocationStorageType.ADLSGen2) {
                items = data.ADLSGen2Location;
            }
            _.each(items, (item, key) => {
                if (!!item && key === 'KeyVaultAuthentication') {
                    resKeyVault.push(this._getDetailGridCol('SecretName', item.SecretName));
                    resKeyVault.push(this._getDetailGridCol('Url', item.Url));
                }
                else if (!!item && key !== 'DataPath') {
                    res.push(React.createElement(GridCol, { xl: locationWidth[key].xl, lg: locationWidth[key].lg, md: locationWidth[key].md, key: `${key}GridCol` }));
                }
            });
        }
        return (React.createElement("div", null,
            React.createElement(GridRow, null,
                React.createElement(GridCol, { xl: "2", lg: "2", md: "3" },
                    React.createElement(Detail, { label: "Data type", value: `${data === null || data === void 0 ? void 0 : data.StorageType}` })),
                res),
            React.createElement(GridRow, null,
                resKeyVault.length > 0 && resKeyVault,
                React.createElement(GridCol, { xl: locationWidth.DataPath.xl, lg: locationWidth.DataPath.lg, md: locationWidth.DataPath.md },
                    React.createElement(Detail, { label: "Data path", value: items === null || items === void 0 ? void 0 : items.DataPath })))));
    }
    _getDetailGridCol(key, item) {
        return (React.createElement(GridCol, { xl: locationWidth[key].xl, lg: locationWidth[key].lg, md: locationWidth[key].md, key: `${key}GridCol` },
            React.createElement(Detail, { label: LocationKeyDetailLabel[key], value: `${item}` })));
    }
}
export default DataSourceLocationView;

//# sourceMappingURL=DataSourceLocation.js.map
